module.exports = __webpack_public_path__ + "static/media/EP_roadbike_fluor.dc53c48e.png";